import React from 'react';
import * as Mapbox from "react-map-gl/mapbox";
import {
  FillLayerSpecification,
  FilterSpecification,
  LayerSpecification,
  LineLayerSpecification,
  SymbolLayerSpecification
} from "mapbox-gl";
import {MapLayer} from "../../../types/MapLayers";

// Types ----

type FloorZoneSpaceLayerProps = {
  source?: string
  enabledLayers: MapLayer[]
  floorId?: number
  beforeId?: string
}

// Component ----

function FloorZoneSpaceLayer({source = '', enabledLayers, floorId, beforeId}: FloorZoneSpaceLayerProps) {

  // Filters
  const spaceFilter: FilterSpecification = ["==", ["get", "type"], "floor-zone-space"];
  const filter: FilterSpecification = floorId ? ['all', spaceFilter, ["==", ["get", "floor_id"], floorId]] : spaceFilter;

  // Layout Properties
  const layout: LayerSpecification['layout'] = { visibility: enabledLayers.includes(MapLayer.ZONE) ? "visible" : "none" };

  return (
    <>
      <Mapbox.Layer
        type="fill"
        id="ngage-floor-zone"
        source={source}
        filter={filter}
        paint={zonePaint}
        layout={layout}
        beforeId={beforeId}
      />

      <Mapbox.Layer
        type="line"
        id="ngage-floor-zone-outline"
        source={source}
        filter={filter}
        paint={zoneOutlinePaint}
        layout={layout}
        beforeId={beforeId}
      />

      <Mapbox.Layer
        type="symbol"
        id="ngage-floor-zone-name"
        source={source}
        filter={filter}
        layout={{...zoneNameLayout, ...layout}}
        paint={zoneNamePaint}
        beforeId={beforeId}
      />
    </>
  );
}

// Styles ----

const zonePaint: FillLayerSpecification['paint'] = {
  "fill-color": "#e0e7ff",
  "fill-opacity": 0.5,
}

const zoneOutlinePaint: LineLayerSpecification['paint'] = {
  "line-color": "#3730a3",
  "line-width": 3,
  "line-opacity": 0.6,
}

const zoneNameLayout: SymbolLayerSpecification['layout'] = {
  "text-field": ["get", "name"],
  "text-anchor": "center",
}

const zoneNamePaint: SymbolLayerSpecification['paint'] = {
  "text-halo-width": 2,
  "text-halo-color": "#ffffff",
}

export default FloorZoneSpaceLayer;